import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import TriggeredProduction from '@/roc/effects/Production/TriggeredProduction';
import EffectAmount from '@/roc/effects/EffectAmount';
import ProcCondition from '@/roc/effects/Production/ProcCondition';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import EraType from '@/roc/era/EraType';

const HagiaSophia = {
  id: '28',
  name: 'Hagia Sophia',
  era: EraType.earlyRome,
  icon: 'hs',
  gameId: 'HagiaSophia',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.GREAT_EMPIRE,
  kind: WonderKind.TEMPLE,
  kindMultiplier: 1,
  owner: WonderOwner.CAPITAL,
  effects: Effects.create([
    new TriggeredProduction(
      EffectAmount.asFlat(5),
      ProcCondition.asCompleteNegotiation(),
      ProductionDuration.asDaily(),
      ProductionOutput.asFlat(1).withOutput(ProductionOutputType.CHEST),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asRangePerLevel([
        {
          min: 250,
          max: 300
        },
        {
          min: 270,
          max: 320
        },
        {
          min: 290,
          max: 340
        },
        {
          min: 310,
          max: 360
        },
        {
          min: 330,
          max: 380
        },    // 5
        {
          min: 350,
          max: 400
        },
        {
          min: 370,
          max: 420
        },
        {
          min: 390,
          max: 440
        },
        {
          min: 410,
          max: 460
        },
        {
          min: 430,
          max: 480
        },  // 10
        {
          min: 450,
          max: 500
        },
        {
          min: 470,
          max: 520
        },
        {
          min: 490,
          max: 540
        },
        {
          min: 510,
          max: 560
        },
        {
          min: 530,
          max: 580
        },  // 15
        {
          min: 550,
          max: 600
        },
        {
          min: 570,
          max: 620
        },
        {
          min: 590,
          max: 640
        },
        {
          min: 610,
          max: 760
        },
        {
          min: 630,
          max: 780
        },  // 20
        {
          min: 650,
          max: 700
        },
        {
          min: 670,
          max: 720
        },
        {
          min: 690,
          max: 740
        },
        {
          min: 710,
          max: 860
        },
        {
          min: 730,
          max: 880
        },  // 25
        {
          min: 750,
          max: 800
        },
        {
          min: 770,
          max: 820
        },
        {
          min: 790,
          max: 840
        },
        {
          min: 810,
          max: 860
        },
        {
          min: 830,
          max: 880
        }  // 30
      ]).withOutput(ProductionOutputType.RANDOM_GOODS),
    ),
  ]),
  synergies: [],
};

export default HagiaSophia;
